import { rate } from 'financial';
import { all, ceil, create, floor, pi, pow, random, randomInt } from 'mathjs';
import { containsFunction } from './functions/contains';
import { ifFunction } from './functions/if';

export const math = create(all);

math.import(
  {
    if: ifFunction,
    contains: containsFunction,
    rate,
    pi: () => pi,
    power: pow,
    roundup: ceil,
    rounddown: floor,
    rand: () => random(0, 1).toFixed(1),
    randbetween: randomInt,
    import: function () {
      throw new Error('Function import is disabled');
    },
    createUnit: function () {
      throw new Error('Function createUnit is disabled');
    }
  },
  { override: true }
);

export const evaluate = (
  formula: string,
  scope: Record<string, unknown> = {}
) => {
  const finalFormula = replaceFormulaScope(formula, scope);

  const value = math.evaluate(finalFormula, scope);

  if (typeof value === 'function') {
    throw new Error('Insufficient arguments of function');
  }

  return value?.toString();
};

const replaceFormulaScope = (
  formula: string,
  scope: Record<string, unknown>
): string => {
  return formula
    .replace(/\{\{([^}]+)\}\}/g, (...matches) => {
      const value = scope[matches[1]] as string | string[];

      if (value === undefined) {
        return '0';
      }

      if (Array.isArray(value)) {
        const arrayValue = value.map((id) => scope[id] as string);
        return [...arrayValue, 0].toString();
      }

      if (scope[value] !== undefined) {
        return scope[value] as string;
      }

      return value as string;
    })
    .replace(/"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|[^'"]+/g, (segment) =>
      segment.startsWith("'") || segment.startsWith('"')
        ? segment
        : segment.toLowerCase()
    );
};
